import {ADMIN_USER, LOGIN_USER, LOGOUT_USER} from '.';
import {AdminPayloadParams, AdminUserAction, LoginPayloadParams, LoginUserAction, LogoutUserAction} from '../mappers/AuthTypesMapper';

export const logoutUser = (
  dispatch: (action: LogoutUserAction) => void
): void => {
  dispatch({
    type: LOGOUT_USER
  });
};

export const loginUser = (
  dispatch: (action: LoginUserAction) => void,
  params: LoginPayloadParams
  ): void => {
  dispatch({
    type: LOGIN_USER,
    payload: params
  });
};

export const checkAdminPortal = (
  dispatch: (action: AdminUserAction) => void,
  params: AdminPayloadParams
  ): void => {
  dispatch({
    type: ADMIN_USER,
    payload: params,
  });
};
